import { ViewList } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { WO2ToggleSwitch } from 'src/common';

interface Props {
  mergeReports: boolean;
  setMergeReportsParameter: (value: boolean) => void;
  setShowItemOderingModalParameter: (value: boolean) => void;
  disabled: boolean;
}

export const MergeReportsToggle = ({
  mergeReports,
  setMergeReportsParameter,
  setShowItemOderingModalParameter,
  disabled,
}: Props): JSX.Element => {
  const theme = useTheme();

  useEffect(() => {
    setMergeReportsParameter(!disabled);
  }, [disabled]);

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box display="flex" alignItems="center">
        <WO2ToggleSwitch
          disabled={disabled}
          checked={mergeReports}
          onChange={() => {
            setMergeReportsParameter(!mergeReports);
          }}
          color="primary"
          name="mergeReports"
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
        <Typography variant="h4">Merge Reports</Typography>
      </Box>
      {mergeReports && (
        <Tooltip title="Manage Report Order">
          <IconButton
            disabled={disabled}
            sx={{ outline: `1px solid ${theme.palette.primary.main}` }}
            color="primary"
            onClick={() => setShowItemOderingModalParameter(true)}
          >
            <ViewList />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
